import { SingleLayoutContainerController } from './single-layout-container.controller';
import { SingleLayoutContainerComponentProps } from './single-layout-container.model';

export const SingleLayoutContainer = (
  props: SingleLayoutContainerComponentProps
): JSX.Element => {
  return <SingleLayoutContainerController {...props} />;
};
